import ApplicationController from "./application_controller"

export default class extends ApplicationController {
  static targets = ["behalf", "name", "submit"]

  connect() {
    this.toggle()
  }

  toggle() {
    const behalfSelected = this.behalfTarget.checked
    this.nameTarget.required = behalfSelected

    if (!behalfSelected) {
      this.nameTarget.value = ""
    }

    this.validate()
  }

  validate() {
    const namePresent = this.nameTarget.value.trim().length > 0
    this.submitTarget.disabled = this.behalfTarget.checked && !namePresent
  }

  submit(event) {
    this.validate()

    if (this.submitTarget.disabled) {
      event.preventDefault()
    }
  }
}
